import styled from "@emotion/styled";
import { fontMerriweather, theme } from "@product/scmp-sdk";

import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  inline-size: 100%;
  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Content = styled.div``;

export const StyledEntityLink = styled(EntityLink)`
  margin-block-end: 12px;

  color: #000000;
  font-weight: 700;
  font-size: 20px;
  font-family: ${fontMerriweather};
  line-height: 140%;
`;

export const Headline = styled.div``;

export const Summary = styled.div`
  margin-block-end: 12px;

  color: #6f6f6f;
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  line-height: 130%;

  &:empty {
    margin: 0;
  }
`;

export const PublishedDate = styled.div`
  color: #999999;
  font-weight: 400;
  font-size: 12px;
`;

export const StyledCoverEntityLink = styled(EntityLink)`
  aspect-ratio: 260/173;

  position: relative;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 260px;
    block-size: 173px;
  }
`;

export const CoverImage = styled.div`
  position: relative;
  aspect-ratio: 260/173;

  inline-size: 100%;
  block-size: 100%;
`;
